import Link from '@splunk/react-ui/Link';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;
`;

const StyledLink = styled(Link)`
    margin: 0 4px;
`;

export default function CustomizableVariablesLink() {
    return (
        <Container>
            To learn more, see a reference of all
            <StyledLink
                to="https://quickdraw.splunk.com/redirect/?product=Observability&location=customize.alert.message.variables&version.current"
                openInNewContext
            >
                message variables
            </StyledLink>
        </Container>
    );
}
